<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-trf">
    <main class="tpl-trf__main">
      <header class="tpl-trf__banner">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-trf__logo" />
      </header>

      <div v-if="showHero" class="tpl-trf__hero">
        <h1 class="tpl-trf__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-trf__hero-sub">{{ quiz.sub_title }}</p>
      </div>

      <div class="tpl-trf__stepper" aria-hidden="true">
        <template v-for="n in Math.max(progress.total, 1)" :key="n">
          <span
            class="tpl-trf__step-dot"
            :class="{ 'tpl-trf__step-dot--done': isGate || n <= progress.current }"
          >
            <template v-if="isGate || n <= progress.current">&#10003;</template>
          </span>
          <span v-if="n < Math.max(progress.total, 1)" class="tpl-trf__step-line"></span>
        </template>
      </div>

      <slot />

      <footer class="tpl-trf__footer">
        <p v-if="quiz.privacy_url">
          <a :href="quiz.privacy_url" target="_blank">{{ quiz.privacy_text || 'Privacy Policy' }}</a>
        </p>
        <p v-if="quiz.legal_name" class="tpl-trf__footer-legal">
          © {{ quiz.legal_name }}<template v-if="quiz.legal_id"> - {{ quiz.legal_id }}</template> - All rights reserved
        </p>
        <p v-if="quiz.disclaimer" class="tpl-trf__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </main>
  </div>
</template>
